fragment FeatureAccessFragment on FeatureAccess {
  UserConfirmedAt
  Description
  IsTenantLegalRequired
  IsUserLegalRequired
  IsTenantApproved
  IsUserApproved
  IsUserAllowedToRead
  FeatureId
  Feature {
    ApiName
    Name
    Description
  }
}
